import React, { useState, useEffect } from "react";
import './Home.css'
import AnswerBubbleSection from "../components/AnswerBubbleSection";
import QuestionBox from "../components/QuestionBox";
import {
    postJson,
    RequestAnswers,
    AnswerFeedback,
    RequestFeedback,
    RequestQuestion,
    TARGET_ANSWERS,
    TARGET_FEEDBACK,
    TARGET_QUESTION,
    urlFor
} from "../utils/comms";
import { getAccessToken, isEOD, recordLastEpoch } from "../utils/cookies";
import QuestionBoxFeedback from "../components/QuestionBoxFeedback";
import QuestionBubble from "../components/QuestionBubble";
import TitleText from "../components/TitleText";
import { formatDateInRome } from "../utils/date";
import { useNavigate } from "react-router-dom";

function isValidQuestionPrompt(value) {
    // TODO: Expand check to meet requirements on user-end;
    return typeof value === 'string' && value.trim().length > 0;
}

function loadOpenAnswers() {
    const tagetUrl = urlFor(TARGET_ANSWERS);
    const authToken = getAccessToken();
    const requestAnswers = new RequestAnswers(authToken);
    const responseAnswers = postJson(tagetUrl, requestAnswers);
    return responseAnswers;
}

function Home() {
    const [questionPrompt, setQuestionPrompt] = useState("");
    const [canQuestionBeSent, setCanQuestionBeSent] = useState(false);

    const [responseQuestion, setResponseQuestion] = useState(null);

    const [responseAnswers, setResponseAnswers] = useState(null);
    const isAnswers = responseAnswers && responseAnswers.answers.length === 2;

    const awaitingAnswers = questionPrompt && responseQuestion && !isAnswers;

    const [requestFeedback, setRequestFeedback] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
     loadOpenAnswers()
       .then((maybeResponseAnswers) => {
           if (maybeResponseAnswers != null) {
               setQuestionPrompt(maybeResponseAnswers.request_question.question_str);
               setResponseQuestion(maybeResponseAnswers.response_question);
               setResponseAnswers(maybeResponseAnswers);
               setRequestFeedback(initialiseRequestFeedback(maybeResponseAnswers));
           }
       })
       .catch(() => {})
    }, []);

    useEffect(() => {
        const pollAnswers = async () => {
            if (!awaitingAnswers) {
                return;
            }
            try {
                const maybeResponseAnswers = await loadOpenAnswers();
                if (maybeResponseAnswers && maybeResponseAnswers.answers.length === 2) {
                    setResponseAnswers(maybeResponseAnswers);
                    setRequestFeedback(initialiseRequestFeedback(maybeResponseAnswers));
                } else {
                    setTimeout(pollAnswers, 2000);
                }
            } catch (error) {
                setResponseQuestion(null);
                setResponseAnswers(null);
                setRequestFeedback(null);
            }
        };
        pollAnswers();
    }, [awaitingAnswers]);

useEffect(() => {
    const pollEOD = async () => {
        if (questionPrompt.trim().length === 0 && !awaitingAnswers && requestFeedback === null) {
            if (isEOD()) {
                navigate("/endofday");
            }
        }
    };

    const intervalId = setInterval(pollEOD, 5000);
    pollEOD(); // Initial check

    return () => clearInterval(intervalId);
}, [questionPrompt, awaitingAnswers, requestFeedback, navigate, isEOD]);

    const submitQuestion = () => {
        const tagetUrl = urlFor(TARGET_QUESTION);
        const requestQuestion = new RequestQuestion(
            getAccessToken(),
            questionPrompt
        );
       postJson(tagetUrl, requestQuestion).then(
           (responseQuestion) => {
                setResponseQuestion(responseQuestion);
           }
       ).catch((err) => {
           alert(err.response.error);
       });
    };

    const onSubmitQuestion = () => {
        setCanQuestionBeSent(false);
        submitQuestion();
    };

    const onQuestionTextChanged = (questionPrompt) => {
        const isValidPrompt = isValidQuestionPrompt(questionPrompt);
        setCanQuestionBeSent(isValidPrompt);
        setQuestionPrompt(questionPrompt);
    };

    const initialiseAnswerFeedback = (answer) => {
        const answerFeedback = new AnswerFeedback();
        answerFeedback.answer_id = answer.answer_id;
        return answerFeedback;
    }

    const initialiseRequestFeedback = (responseAnswers) => {
        const requestFeedback = new RequestFeedback();
        requestFeedback.auth_token = getAccessToken();
        requestFeedback.qa_id = responseAnswers.qa_id;
        requestFeedback.answer_feedbacks = [
            initialiseAnswerFeedback(responseAnswers.answers[0]),
            initialiseAnswerFeedback(responseAnswers.answers[1])
        ];
        return requestFeedback;
    }

    const updateRequestFeedback = (updates) => {
        setRequestFeedback((requestFeedback) => {
            const newRequestFeedback = { ...requestFeedback, ...updates };
            return newRequestFeedback;
        });
    };

    const onSubmitFeedback = () => {
       const tagetUrl = urlFor(TARGET_FEEDBACK);
       postJson(tagetUrl, requestFeedback).then(
           (responseFeedback) => {
                setQuestionPrompt("");
                setResponseQuestion(null);
                setResponseAnswers(null);
                setRequestFeedback(null);
                recordLastEpoch();
           }
       ).catch((err) => {
           alert(err.response.error);
       });
    };

    return (
        <div>
            { awaitingAnswers && (
                <div className="home-container">
                   <QuestionBubble
                        text={questionPrompt}
                   />
                   <TitleText
                       text={
                            `The responses are being processed, and should be ready by ${formatDateInRome(responseQuestion.epoch_rome)}`
                        }
                   />
                </div>
            )}
            { isAnswers &&
                <div className="home-container">
                   <QuestionBubble
                        text={questionPrompt}
                   />
                   <AnswerBubbleSection
                        onUpdatedRequestFeedback={updateRequestFeedback}
                        requestFeedback={requestFeedback}
                        answers={responseAnswers.answers}
                   />
                </div>
            }
            { isAnswers &&
                <QuestionBoxFeedback
                    isSubmitEnabled={true}
                    onSubmit={onSubmitFeedback}
                />
            }
            { !isAnswers && !awaitingAnswers &&
                <QuestionBox
                    onSubmitQuestion={onSubmitQuestion}
                    onQuestionTextChanged={onQuestionTextChanged}
                    isEnabled={canQuestionBeSent}
                />
            }
        </div>
    )
}

export default Home;

